import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Status')
export class Status {
  @JsonProperty('code', String, false) code: string = undefined;
  @JsonProperty('description', String, false) description: string = undefined;
}
